import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service'
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public authForm: FormGroup;
  isSubmitted = false;

  constructor(
    public authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {

    if (this.authService.user$ != null) {
      this.router.navigate(['/home']);
    }

    this.authForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });

  }

  public signIn() {

    this.isSubmitted = true;
    if (this.authForm.invalid) {
      return;
    }

    this.authService.signIn(this.authForm.value);

  }

  get formControls() {
    return this.authForm.controls;
  }
}

  


